<div class="mt-4 mb-4" *ngIf="rma">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/inventory/rma']">Retours Fournisseurs</button></li>
    <li class="breadcrumb-item active"><button class="btn btn-sm btn-link" disabled>{{ rma.number }}</button></li>
  </ol>
</div>

<div class="pb-2 bg-white rounded shadow-sm container-fluid" *ngIf="rma">
  <div class="mb-3 d-flex row text-center">
    <div class="p-2 col-xl">
      <h5>{{ rma.supplier.name }}</h5>
      <div>Retour {{ rma.number }}</div>
      <div>{{ rma.details.length }} référence(s)</div>
    </div>
    
    <div class="p-2 col-xl">
      <div>
        <rma-status [status]="rma.status"></rma-status>
      </div>
    </div>

    <div class="p-2 col-xl">
      &nbsp;
    </div>

    <div class="p-2 col-xl-4">
      <div>Ouvert le <strong>{{ rma.creationTimestamp | date: 'medium' }}</strong></div>
      <div *ngIf="rma.confirmTimestamp">Confirmé le <strong>{{ rma.confirmTimestamp | date: 'medium' }}</strong></div>
      <div *ngIf="rma.cancelTimestamp">Annulé le <strong>{{ rma.cancelTimestamp | date: 'medium' }}</strong></div>
    </div>
  </div>

  <div class="mb-3 input-group" *ngIf="rma.status == 'OPEN'">
    <input type="text" class="form-control" placeholder="Recherche référence" [attr.disabled]="loading ? 'DISABLED' : null" (keyup)="onSearchKeyup($event)" [(ngModel)]="query" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" [attr.disabled]="loading ? 'DISABLED' : null" type="button" (click)="search()">
        <i *ngIf="!searchInProgress" class="bi bi-search"></i>
        <span *ngIf="searchInProgress" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
    </div>
  </div>

  <div class="p-3 mb-3 bg-light rounded shadow-sm" *ngFor="let detail of rma.details">
    <div class="d-flex small lh-sm">
      <div class="align-self-center text-center">
        <reference-image [reference]="detail.reference"></reference-image>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg">
            <div>
              {{ detail.reference.title }}
              <a class="ml-2" [routerLink]="['/inventory/reference', detail.reference.isbn]" target="_blank">
                <i class="bi bi-card-heading"></i>
              </a>
            </div>
            <div>{{ detail.reference.isbn }}</div>
            <div>{{ detail.reference.publisher }}</div>
          </div>
          <div class="col-lg-2 col-xl-2 pr-3 align-self-center mt-1 mb-1">{{ detail.reference.supplierReferences[0].supplier.name }}</div>
          <div class="col-lg pl-3 pr-3 align-self-center d-flex">
            <div class="align-self-center text-nowrap">{{ detail.reference.supplierReferences[0].retailPrice / 100 | number:'1.2-2' }} $ x</div>
            <input type="number" min="1" max="999" class="form-control ml-1 mr-1 align-self-center" [(ngModel)]="detail.quantity" (ngModelChange)="updateQuantity(detail)" />
            <div class="text-nowrap d-flex">
              <span class="align-self-center">=</span>
              <div class="total align-self-center ml-auto text-right"> {{ detail.reference.supplierReferences[0].retailPrice * detail.quantity / 100 | number:'1.2-2' }} $</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-auto align-self-center">
        <button class="btn btn-sm btn-outline-secondary" (click)="removeDetail(detail)"><span class="bi bi-trash"></span></button>
      </div>
    </div>
  </div>

  <div class="pb-3 d-flex" *ngIf="rma.status == 'OPEN'">
    <button class="btn btn-sm btn-danger" [attr.disabled]="loading ? 'DISABLED' : null" (click)="cancel()">Annuler</button>
    <button class="btn btn-sm btn-success ml-auto" [attr.disabled]="loading ? 'DISABLED' : null" (click)="confirmRma()">Confirmer le retour</button>
  </div>
</div>